import { createBrowserRouter } from 'react-router'
import { AppShell } from '@/components/layout/AppShell'
import { HomePage } from '@/pages/HomePage'

export const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'convert', lazy: async () => ({ Component: (await import('@/pages/ConvertPage')).ConvertPage }) },
      { path: 'markets', lazy: async () => ({ Component: (await import('@/pages/MarketsPage')).MarketsPage }) },
      { path: 'markets/:id', lazy: async () => ({ Component: (await import('@/pages/AssetPage')).AssetPage }) },
      { path: 'forecasts', lazy: async () => ({ Component: (await import('@/pages/ForecastsPage')).ForecastsPage }) },
      { path: 'pro', lazy: async () => ({ Component: (await import('@/pages/ProPage')).ProPage }) },
      { path: 'settings', lazy: async () => ({ Component: (await import('@/pages/SettingsPage')).SettingsPage }) },
      { path: 'more', lazy: async () => ({ Component: (await import('@/pages/MorePage')).MorePage }) },
      { path: 'about', lazy: async () => ({ Component: (await import('@/pages/AboutPage')).AboutPage }) },
      { path: '*', lazy: async () => ({ Component: (await import('@/pages/NotFoundPage')).NotFoundPage }) },
    ],
  },
])
